import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MgbOverview from './MgbOverview';
import MgbOrder from './MgbOrder';

export default function Mgb({ match }) {
  return (
    <Switch>
      <Route path={match.path} component={MgbOverview} exact />
      <Route path={`${match.path}/:id`} component={MgbOrder} />
    </Switch>
  );
}



// WEBPACK FOOTER //
// ./src/views/skidata/components/Mgb.jsx